import Page from '~/components/layout/page/Page';
import {
  ExchangeOptionsProvider,
  useExchangeSelection,
} from './exchangeOptions';
import ProductSelectionGrid from './ProductSelectionGrid';
import ProductVariantSelector from './ProductVariantSelector';

function ProductExchangeCard() {
  const [{ selectedProduct }] = useExchangeSelection();
  return (
    <Page.Section title={!selectedProduct ? 'The product you will get' : ''}>
      <ProductVariantSelector />
      <ProductSelectionGrid />
    </Page.Section>
  );
}

export default function ProductExchange() {
  return (
    <ExchangeOptionsProvider>
      <ProductExchangeCard />
    </ExchangeOptionsProvider>
  );
}
